import TableButton from 'components/common/Buttons/TableButton'
import LoadingWithFeedback from 'components/common/Loading/LoaderWithFeedback'
import Table from 'components/common/Table'
import { MediatorContext } from 'context/MediatorContext'
import { reloadTableContext } from 'context/ReloadTableContext'
import useQuery from 'hooks/useQuery'
import React, { useContext, useMemo, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Roles } from 'utils/enums'
import Calls from '../Calls'

const TranslatorsTable = () => {
  const params = useParams()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const { translators, setPendingRequests } = useContext(MediatorContext)

  const { reloadTable } = useContext(reloadTableContext)
  const { makeRequest } = useQuery({
    defaultEndpoint: '/mediators/createRoom',
    defaultMethod: 'post',
    isControlled: true,
    toastOptions: {
      resultMessageError: {
        400: 'Cuenta desconectada o sin solicitudes pendientes',
      },
    },
  })

  const { makeRequest: clearStatus } = useQuery({ isControlled: true })

  const [selectedTranslator, setSelectedTranslator] = useState(null)

  const selectTranslatorHandler = async (id) => {
    const accountId = params?.id
    const requestId = searchParams.get('requestId')
    const { code, error } = await makeRequest({
      body: { accountId, requestId, translatorId: id },
    })
    if (!error) {
      setPendingRequests((ps) => ps.filter((pr) => pr.id !== (requestId || accountId)))
      navigate('/mediators')
    } else if (code === 400) {
      reloadTable()
    }
  }
  const COLUMNS_TO_REPLACE = {
    status: {
      Header: 'Estado',
      accessor: ({ id, status }) => (
        <div className='flex justify-center items-center gap-2'>
          <div
            className={`w-4 h-4 mr-2 rounded-full ${Roles.Translator.statuses[status].color}`}
          />
          <span>{status}</span>
          {status === Roles.Translator.statuses['En Llamada'].value && (
            <TableButton
              clickHandler={async () => {
                const { error } = await clearStatus({
                  endpoint: `/mediators/translators/${id}/setAvailable`,
                })
                if (!error) reloadTable()
              }}
            >
              Disponibilizar
            </TableButton>
          )}
        </div>
      ),
      id: 'status',
    },
  }
  const ADITIONAL_COLUMNS = [
    {
      Header: 'Llamadas',
      Cell: ({
        row: {
          original: { id, calls, email },
        },
        cellCustomData,
      }) => {
        return (
          <TableButton
            selected={id === cellCustomData?.id}
            clickHandler={() =>
              setSelectedTranslator((ps) =>
                ps?.id === id
                  ? null
                  : {
                    endpoint: calls,
                    title: `Puesto: ${email}`,
                    id,
                  })}
          >
            Ver Llamadas
          </TableButton>
        )
      },
    },
    ...(params?.id
      ? [
        {
          Header: 'Seleccionar Intérprete',
          accessor: ({
            id, firstName, lastName, status,
          }) => (
            <LoadingWithFeedback
              action={() => selectTranslatorHandler(id)}
              disabled={
                  status !== Roles.Translator.statuses.Conectado.value
                  || !firstName
                  || !lastName
                }
              >
              Seleccionar
            </LoadingWithFeedback>
          ),
        },
      ]
      : []),
  ]

  return (
    <Table
      endpoint='/mediators/translators'
      tableData={translators}
      aditionalColumns={ADITIONAL_COLUMNS}
      title='Mis Puestos'
      searchOptions={SEARCH_OPTIONS}
      orderOptions={ORDER_OPTIONS}
      columnsToReplace={COLUMNS_TO_REPLACE}
      cellCustomData={selectedTranslator}
      disableAutoScroll
    >
      {selectedTranslator && (
        <Calls
          endpoint={selectedTranslator.endpoint}
          title={selectedTranslator.title}
          columnsToSkip={CALLS_COLUMNS_TO_SKIP}
        />
      )}
    </Table>
  )
}

const SEARCH_OPTIONS = ['email', 'firstName', 'lastName', 'speciality']
const ORDER_OPTIONS = [
  'email',
  'speciality',
  'firstName',
  'lastName',
  'status',
]
const CALLS_COLUMNS_TO_SKIP = ['translatorEmail']

export default TranslatorsTable
